module.exports = __webpack_public_path__ + "img/df80a85.jpg";